import { useState } from "react";
import Config from './config.json';

// ======================================================= //

export function useForceUpdate() {
    
    // eslint-disable-next-line 
    const [value, setValue] = useState(0); 
    return () => setValue(value => value + 1);
}

// ------------------------------------------------------- //

const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
export function getDayIndex(day) {
    return days.indexOf(day);
}

// ------------------------------------------------------- //

export function getConfig() {
    return Config;
}